import { Components, Theme } from '@mui/material';

export const MuiAutocomplete: Components<
  Omit<Theme, 'components'>
>['MuiAutocomplete'] = {
  styleOverrides: {
    root: {
      '& .MuiAutocomplete-inputRoot': {
        '& .MuiAutocomplete-input': {
          width: 'max-content',
        },
      },
    },
  },
};
